import { URLS } from "@/constants/urls";
import {
  Attributes,
  CatalogEntryIdentifier,
  Description,
} from "@/types/config.types";

export interface ICatalogEntry {
  catalogEntryIdentifier: CatalogEntryIdentifier;
  offerPrice?: string;
  description: Description[];
  attributes: Attributes;
}

export interface IContactLensByIdResponse {
  catalogEntry: ICatalogEntry;
}

export const getContactLensById = async (
  storeId: string,
  catalogId: string,
  productId: string,
  basePath: string = window.location.origin,
): Promise<IContactLensByIdResponse> => {
  return new Promise((resolve, reject) => {
    const url = (basePath + URLS.CONTACT_LENSES_BY_ID)
      .replace("{storeId}", storeId)
      .replace("{catalogId}", catalogId)
      .replace("{productId}", productId);

    fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (!response.ok) {
          reject(response);
          return;
        }
        return response.json();
      })
      .then((data: IContactLensByIdResponse) => {
        resolve(data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};
